<template>
  <div class="container zeroxa index">
    <h1 class="title">0xa</h1>

    <div class="section items">
      <div class="row">
        <div class="col">
          <h2>NFT & POAP Items
            <small v-if="!loading" class="text-muted">All {{items.length}} of them </small>
            <small v-else>loading...</small>
          </h2>
          <ZeroxaItem v-for="item in items" :key="item.id" :item="item"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './../style/zeroxa.scss'
import ZeroxaItem from './../components/ZeroxaItem.vue'
import { tokenMixin } from 'rph-slides-vue/src/mixins/tokenMixin.js'

export default {
  name: 'ZeroxaIndex',
  components: { ZeroxaItem },
  mixins: [tokenMixin],
  data () {
    return {
      items: [],
      loading: false
    }
  },
  computed: {},
  created () {
    this.$socket.emit('/zeroxa', {}, this.onItemsUpdate.bind(this))
    this.loading = true
  },
  methods: {
    onItemsUpdate (resp) {
      console.log('onItemsUpdate', resp)
      this.items = resp.data
      this.loading = false
    }
  }
}
</script>
